import * as types from "./../action-types";
import axios from "axios";
import { compact, get } from "lodash";

async function fetchDeviceRegistries({ commit }, { customer_id, params = {} }) {
  try {
    const registries = await axios.get(
      `/v2/customers/${customer_id}/ring_device_registries`,
      { params }
    );
    let third_party_devices = registries.data.third_party_devices;

    let doorbot_ids = registries.data.ring_devices
      .filter((device) => !device.type.startsWith("tc_"))
      .map((device) => device.doorbot_id);
    let data = {
      registries: doorbot_ids,
      third_party_devices: third_party_devices,
    };
    commit(types.FETCH_DEVICE_REGISTRIES.SUCCESS, data);
    return {
      data: { doorbot_ids },
    };
  } catch (error) {
    commit(types.FETCH_DEVICE_REGISTRIES.ERROR);
    throw error.response;
  }
}

async function fetchDeviceList({ commit }, { doorbot_ids, params = {} }) {
  try {
    let httpRequests = doorbot_ids.map((doorbot_id) => {
      return axios
        .get(`/v2/devices/${doorbot_id}/aggregate`, { params })
        .catch((_err) => null);
    });
    let responses = compact(await axios.all(httpRequests));
    let devices = responses.map((resp) => get(resp, "data.device", null));

    commit(types.FETCH_DEVICE_LIST.SUCCESS, devices);
    return { data: devices };
  } catch (error) {
    commit(types.FETCH_DEVICE_LIST.ERROR);
    throw error.response;
  }
}

async function fetchSimpleDeviceList({ commit }, { customer_id, params = {} }) {
  try {
    const registries = await axios.get(
      `/v2/customers/${customer_id}/ring_device_registries`,
      params
    );

    const devices = registries.data.ring_devices;

    commit(types.FETCH_SIMPLE_DEVICE_LIST.SUCCESS, devices);
    return { data: devices };
  } catch (error) {
    commit(types.FETCH_SIMPLE_DEVICE_LIST.ERROR);
    throw error.response;
  }
}

async function getDeviceStatuses({}, { devices }) {
  devices = devices || [];
  try {
    const response = await axios.get(`v2/devices/status`, {
      params: { devices },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getWarrantyAndEligibilityStatus(
  { dispatch },
  { devices, customerId: customer_id, category, locationId: locationId }
) {
  devices = devices || [];

  if (category && !["device", "accessory"].includes(category)) {
    throw new Error('Category must be either "device" or "accessory"');
  }
  try {
    const response = await axios.get(`v2/devices/validate_eligibility`, {
      params: { devices, customer_id, category },
    });

    // TODO THIS CALL SHOULD REPLACE THE ABOVE FOR WARRANTY AND ELIGIBILITY
    // Get Devices Delayed fulfillment
    if (category === "device") {
      const deviceIds = devices.map((device) => device.device_id);
      const newEligibilityStatus = await dispatch("getDevicesEligibility", {
        deviceIds,
        customerId: customer_id,
        locationId: locationId,
      });
      // For each device inject fulfillment status using the new eligibility data
      Object.keys(response.data).forEach((deviceId) => {
        const matchingDevice = newEligibilityStatus.find(
          (d) => d.device_id === deviceId
        );
        if (matchingDevice) {
          response.data[deviceId].eligibility = {
            ...response.data[deviceId].eligibility,
            is_delayed_fulfillment:
              matchingDevice.eligibility.is_delayed_fulfillment,
            delayed_fulfillment_reason:
              matchingDevice.eligibility.delayed_fulfillment_reason,
          };
        }
      });
    }
    return response.data || {};
  } catch (error) {
    throw error;
  }
}

async function getDevicesEligibility(
  {},
  { deviceIds, customerId, locationId, devicesLocationCountry }
) {
  try {
    const eligibilityStatus = await axios.get(`v2/devices/eligibility`, {
      params: {
        ids: deviceIds,
        customer_id: customerId ? customerId : undefined,
        location_id: locationId ? locationId : undefined,
        devices_location_country: devicesLocationCountry
          ? devicesLocationCountry
          : undefined,
      },
    });

    return eligibilityStatus.data;
  } catch (error) {
    console.error("Error fetching devices eligibility:", error);
  }
}

async function getDeviceTroubleshooting({}, { devices }) {
  devices = devices || [];
  try {
    const response = await axios.get(`v2/devices/troubleshooting`, {
      params: { devices },
    });
    return response.data["troubleshooting"] || {};
  } catch (error) {
    throw error;
  }
}

export default {
  fetchDeviceList,
  fetchSimpleDeviceList,
  getDeviceStatuses,
  getWarrantyAndEligibilityStatus,
  getDeviceTroubleshooting,
  fetchDeviceRegistries,
  getDevicesEligibility,
};
